import { OtherUseInconsistencyOnlyInZendra } from './other-use-inconsistency-only-in-zendra/other-use-inconsistency-only-in-zendra';
import { GisProtectedAreaInconsistencyOnlyInZendra } from './gis-protected-area-inconsistency-only-in-zendra/gis-protected-area-inconsistency-only-in-zendra';
import { GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG } from './gis-protected-area-inconsistency-only-in-zendra/gis-protected-area-inconsistency-only-in-zendra.config';
import { Routes } from '@angular/router';
import { authGuard, permissionGuard } from '@abp/ng.core';
import { CYCLE_CONFIG } from './cycle/cycle.config';
import { CONTRACTASSIGNMENTBYSTAND_CONFIG } from './contract-assignment-by-stand/contract-assignment-by-stand.config';
import { STANDDIVISION_CONFIG } from './stand-division/stand-division.config';
import { discardStandDivisionStateOnHomeNavigation } from './stand-division/stand-division-home-navigation.guard';
import { STANDDIVISIONANDFUSION_CONFIG } from './stand-division-and-fusion/stand-division-and-fusion.config';
import { STANDFUSION_CONFIG } from './stand-fusion/stand-fusion.config';
import { INTERVENTION_CONFIG } from './intervention/intervention.config';
import { INTERVENTIONSOIL_CONFIG } from './intervention-soil/intervention-soil.config';
import { OTHERUSEBYCONSERVATIONTYPE_CONFIG } from './other-use-by-conservation-type/other-use-by-conservation-type.config';
import { PLANTATION_CONFIG } from './plantation/plantation.config';
import { ROTATION_CONFIG } from './rotation/rotation.config';
import { STANDAREAMAINTENANCE_CONFIG } from './stand-area-maintenance/stand-area-maintenance.config';
import { STANDAREAMAINTENANCENOTUPDATED_CONFIG } from './stand-area-maintenance-not-updated/stand-area-maintenance-not-updated.config';
import { STANDDEACTIVATION_CONFIG } from './stand-deactivation/stand-deactivation.config';
import { STANDSOIL_CONFIG } from './stand-soil/stand-soil.config';
import { ContractAssignmentByStand } from './contract-assignment-by-stand/contract-assignment-by-stand';
import { Cycle } from './cycle/cycle';
import { Intervention } from './intervention/intervention';
import { InterventionSoil } from './intervention-soil/intervention-soil';
import { OtherUseByConservationType } from './other-use-by-conservation-type/other-use-by-conservation-type';
import { Plantation } from './plantation/plantation';
import { PlantationsToGenerate } from './plantations-to-generate/plantations-to-generate';
import { Rotation } from './rotation/rotation';
import { StandAreaMaintenance } from './stand-area-maintenance/stand-area-maintenance';
import { StandAreaMaintenanceNotUpdated } from './stand-area-maintenance-not-updated/stand-area-maintenance-not-updated';
import { StandDeactivation } from './stand-deactivation/stand-deactivation';
import { StandSoil } from './stand-soil/stand-soil';
import { StandDivision } from './stand-division/stand-division';
import { StandDivisionAndFusion } from './stand-division-and-fusion/stand-division-and-fusion';
import { StandFusion } from './stand-fusion/stand-fusion';
import { Stand } from './stand/stand';
import { STAND_CONFIG } from './stand/stand.config';
import { GISSTANDPERREGISTER_CONFIG } from './gis-stand-per-register/gis-stand-per-register.config';
import { STANDCYCLEROTATION_CONFIG } from './stand-cycle-rotation/stand-cycle-rotation.config';
import { WOODCERTIFICATION_CONFIG } from './wood-certification/wood-certification.config';
import { GisStandPerRegister } from './gis-stand-per-register/gis-stand-per-register';
import { StandCycleRotation } from './stand-cycle-rotation/stand-cycle-rotation';
import { WoodCertification } from './wood-certification/wood-certification';
import { StandPerRegister } from './stand-per-register/stand-per-register';
import { STANDPERREGISTER_CONFIG } from './stand-per-register/stand-per-register.config';
import { StandCycleRotationHarvestPreparation } from './stand-cycle-rotation-harvest-preparation/stand-cycle-rotation-harvest-preparation';
import { HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG } from './stand-cycle-rotation-harvest-preparation/stand-cycle-rotation-harvest-preparation.config';
import { FORESTRYBASE_CONFIG } from './forestry-base/forestry-base.config';
import { FORESTRYBASE_VARIATIONS_CONFIG } from './forestry-base-variations/forestry-base-variations.config';
import { PROTECTEDAREA_CONFIG } from './protected-area/protected-area.config';
import { PROTECTEDAREAOTHERUSEDETAIL_CONFIG } from './protected-area-other-use-detail/protected-area-other-use-detail.config';
import { STANDTRANSFORMATIONHISTORY_CONFIG } from './stand-transformation-history/stand-transformation-history.config';
import { STANDTRANSFORMATIONHISTORYDETAIL_CONFIG } from './stand-transformation-history-detail/stand-transformation-history-detail.config';
import { WOODCERTIFICATIONDETAIL_CONFIG } from './wood-certification-detail/wood-certification-detail.config';
import { WOODCERTIFICATIONDETAILTYPE_CONFIG } from './wood-certification-detail-type/wood-certification-detail-type.config';
import { PROPERTYORIGINDESTINATION_CONFIG } from './property-origin-destination/property-origin-destination.config';
import { ForestryBase } from './forestry-base/forestry-base';
import { ForestryBaseVariations } from './forestry-base-variations/forestry-base-variations';
import { ProtectedArea } from './protected-area/protected-area';
import { ProtectedAreaOtherUseDetail } from './protected-area-other-use-detail/protected-area-other-use-detail';
import { StandTransformationHistory } from './stand-transformation-history/stand-transformation-history';
import { StandTransformationHistoryDetail } from './stand-transformation-history-detail/stand-transformation-history-detail';
import { WoodCertificationDetail } from './wood-certification-detail/wood-certification-detail';
import { WoodCertificationDetailType } from './wood-certification-detail-type/wood-certification-detail-type';
import { OtherUse } from './other-use/other-use';
import { OTHERUSE_CONFIG } from './other-use/other-use.config';
import { PropertyOriginDestination } from './property-origin-destination/property-origin-destination';
import { PROPERTY_CONFIG } from './property/property.config';
import { Property } from './property/property';
import { PLANTATIONS_TO_GENERATE_CONFIG } from './plantations-to-generate/plantations-to-generate.config';
import { GISSTANDINCONSISTENCYONLYINGIS_CONFIG } from './gis-stand-inconsistency-only-in-gis/gis-stand-inconsistency-only-in-gis.config';
import { GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG } from './gis-stand-inconsistency-only-in-zendra/gis-stand-inconsistency-only-in-zendra.config';
import { GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG } from './gis-stand-inconsistency-disabled-in-zendra/gis-stand-inconsistency-disabled-in-zendra.config';
import { GisStandInconsistencyOnlyInGis } from './gis-stand-inconsistency-only-in-gis/gis-stand-inconsistency-only-in-gis';
import { GisStandInconsistencyOnlyInZendra } from './gis-stand-inconsistency-only-in-zendra/gis-stand-inconsistency-only-in-zendra';
import { GisStandInconsistencyDisabledInZendra } from './gis-stand-inconsistency-disabled-in-zendra/gis-stand-inconsistency-disabled-in-zendra';
import { GISINCONSISTENCYDASHBOARD_CONFIG } from './gis-inconsistency-dashboard/gis-inconsistency-dashboard.config';
import { GisInconsistencyDashboard } from './gis-inconsistency-dashboard/gis-inconsistency-dashboard';
import { OtherUseInconsistencyOnlyInGis } from './other-use-inconsistency-only-in-gis/other-use-inconsistency-only-in-gis';
import { GISSTANDAREADIFFERENCE_CONFIG } from './gis-stand-area-difference/gis-stand-area-difference.config';
import { GisStandAreaDifference } from './gis-stand-area-difference/gis-stand-area-difference';
import { GISREGISTERINCONSISTENCYONLYINGIS_CONFIG } from './gis-register-inconsistency-only-in-gis/gis-register-inconsistency-only-in-gis.config';
import { GisRegisterInconsistencyOnlyInGis } from './gis-register-inconsistency-only-in-gis/gis-register-inconsistency-only-in-gis';
import { GisRegisterInconsistencyOnlyInZendra } from './gis-register-inconsistency-only-in-zendra/gis-register-inconsistency-only-in-zendra';
import { GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG } from './gis-register-inconsistency-only-in-zendra/gis-register-inconsistency-only-in-zendra.config';
import { GisProtectedAreaInconsistencyOnlyInGis } from './gis-protected-area-inconsistency-only-in-gis/gis-protected-area-inconsistency-only-in-gis';
import { GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG } from './gis-protected-area-inconsistency-only-in-gis/gis-protected-area-inconsistency-only-in-gis.config';

export const GEOGRAPHIC_ROUTES: Routes = [
  {
    path: 'stand-division',
    pathMatch: 'full',
    component: StandDivision,
    canActivate: [authGuard, permissionGuard],
    canDeactivate: [discardStandDivisionStateOnHomeNavigation],
    data: {
      requiredPolicy: STANDDIVISION_CONFIG.permission,
      showInMenu: STANDDIVISION_CONFIG.showInMenu,
      menuCategory: STANDDIVISION_CONFIG.menuCategory,
      menuSubcategory: STANDDIVISION_CONFIG.menuSubcategory,
      menuTitle: STANDDIVISION_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-division-and-fusion',
    pathMatch: 'full',
    component: StandDivisionAndFusion,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDDIVISIONANDFUSION_CONFIG.permission,
      showInMenu: STANDDIVISIONANDFUSION_CONFIG.showInMenu,
      menuCategory: STANDDIVISIONANDFUSION_CONFIG.menuCategory,
      menuSubcategory: STANDDIVISIONANDFUSION_CONFIG.menuSubcategory,
      menuTitle: STANDDIVISIONANDFUSION_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-fusion',
    pathMatch: 'full',
    component: StandFusion,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDFUSION_CONFIG.permission,
      showInMenu: STANDFUSION_CONFIG.showInMenu,
      menuCategory: STANDFUSION_CONFIG.menuCategory,
      menuSubcategory: STANDFUSION_CONFIG.menuSubcategory,
      menuTitle: STANDFUSION_CONFIG.localizationKey,
    },
  },
  {
    path: 'contract-assignment-by-stand',
    pathMatch: 'full',
    component: ContractAssignmentByStand,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CONTRACTASSIGNMENTBYSTAND_CONFIG.permission,
      showInMenu: CONTRACTASSIGNMENTBYSTAND_CONFIG.showInMenu,
      menuCategory: CONTRACTASSIGNMENTBYSTAND_CONFIG.menuCategory,
      menuSubcategory: CONTRACTASSIGNMENTBYSTAND_CONFIG.menuSubcategory,
      menuTitle: CONTRACTASSIGNMENTBYSTAND_CONFIG.localizationKey,
    },
  },
  {
    path: 'cycle',
    pathMatch: 'full',
    component: Cycle,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: CYCLE_CONFIG.permission,
      showInMenu: CYCLE_CONFIG.showInMenu,
      menuCategory: CYCLE_CONFIG.menuCategory,
      menuSubcategory: CYCLE_CONFIG.menuSubcategory,
      menuTitle: CYCLE_CONFIG.localizationKey,
    },
  },
  {
    path: 'intervention',
    pathMatch: 'full',
    component: Intervention,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERVENTION_CONFIG.permission,
      showInMenu: INTERVENTION_CONFIG.showInMenu,
      menuCategory: INTERVENTION_CONFIG.menuCategory,
      menuSubcategory: INTERVENTION_CONFIG.menuSubcategory,
      menuTitle: INTERVENTION_CONFIG.localizationKey,
    },
  },
  {
    path: 'intervention-soil',
    pathMatch: 'full',
    component: InterventionSoil,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: INTERVENTIONSOIL_CONFIG.permission,
      showInMenu: INTERVENTIONSOIL_CONFIG.showInMenu,
      menuCategory: INTERVENTIONSOIL_CONFIG.menuCategory,
      menuSubcategory: INTERVENTIONSOIL_CONFIG.menuSubcategory,
      menuTitle: INTERVENTIONSOIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'other-use-by-conservation-type',
    pathMatch: 'full',
    component: OtherUseByConservationType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OTHERUSEBYCONSERVATIONTYPE_CONFIG.permission,
      showInMenu: OTHERUSEBYCONSERVATIONTYPE_CONFIG.showInMenu,
      menuTitle: OTHERUSEBYCONSERVATIONTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'plantation',
    pathMatch: 'full',
    component: Plantation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANTATION_CONFIG.permission,
      showInMenu: PLANTATION_CONFIG.showInMenu,
      menuCategory: PLANTATION_CONFIG.menuCategory,
      menuSubcategory: PLANTATION_CONFIG.menuSubcategory,
      menuTitle: PLANTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'plantations-to-generate',
    pathMatch: 'full',
    component: PlantationsToGenerate,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PLANTATIONS_TO_GENERATE_CONFIG.permission,
      showInMenu: PLANTATIONS_TO_GENERATE_CONFIG.showInMenu,
      menuCategory: PLANTATIONS_TO_GENERATE_CONFIG.menuCategory,
      menuSubcategory: PLANTATIONS_TO_GENERATE_CONFIG.menuSubcategory,
      menuTitle: PLANTATIONS_TO_GENERATE_CONFIG.localizationKey,
    },
  },
  {
    path: 'rotation',
    pathMatch: 'full',
    component: Rotation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: ROTATION_CONFIG.permission,
      showInMenu: ROTATION_CONFIG.showInMenu,
      menuCategory: ROTATION_CONFIG.menuCategory,
      menuSubcategory: ROTATION_CONFIG.menuSubcategory,
      menuTitle: ROTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-area-maintenance',
    pathMatch: 'full',
    component: StandAreaMaintenance,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDAREAMAINTENANCE_CONFIG.permission,
      showInMenu: STANDAREAMAINTENANCE_CONFIG.showInMenu,
      menuCategory: STANDAREAMAINTENANCE_CONFIG.menuCategory,
      menuSubcategory: STANDAREAMAINTENANCE_CONFIG.menuSubcategory,
      menuTitle: STANDAREAMAINTENANCE_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-area-maintenance-not-updated',
    pathMatch: 'full',
    component: StandAreaMaintenanceNotUpdated,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDAREAMAINTENANCENOTUPDATED_CONFIG.permission,
      showInMenu: STANDAREAMAINTENANCENOTUPDATED_CONFIG.showInMenu,
      menuCategory: STANDAREAMAINTENANCENOTUPDATED_CONFIG.menuCategory,
      menuSubcategory: STANDAREAMAINTENANCENOTUPDATED_CONFIG.menuSubcategory,
      menuTitle: STANDAREAMAINTENANCENOTUPDATED_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-deactivation',
    pathMatch: 'full',
    component: StandDeactivation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDDEACTIVATION_CONFIG.permission,
      showInMenu: STANDDEACTIVATION_CONFIG.showInMenu,
      menuCategory: STANDDEACTIVATION_CONFIG.menuCategory,
      menuSubcategory: STANDDEACTIVATION_CONFIG.menuSubcategory,
      menuTitle: STANDDEACTIVATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-soil',
    pathMatch: 'full',
    component: StandSoil,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDSOIL_CONFIG.permission,
      showInMenu: STANDSOIL_CONFIG.showInMenu,
      menuCategory: STANDSOIL_CONFIG.menuCategory,
      menuSubcategory: STANDSOIL_CONFIG.menuSubcategory,
      menuTitle: STANDSOIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand',
    pathMatch: 'full',
    component: Stand,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STAND_CONFIG.permission,
      showInMenu: STAND_CONFIG.showInMenu,
      menuCategory: STAND_CONFIG.menuCategory,
      menuSubcategory: STAND_CONFIG.menuSubcategory,
      menuTitle: STAND_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-stand-per-register',
    pathMatch: 'full',
    component: GisStandPerRegister,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISSTANDPERREGISTER_CONFIG.permission,
      showInMenu: GISSTANDPERREGISTER_CONFIG.showInMenu,
      menuCategory: GISSTANDPERREGISTER_CONFIG.menuCategory,
      menuSubcategory: GISSTANDPERREGISTER_CONFIG.menuSubcategory,
      menuTitle: GISSTANDPERREGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-per-register',
    pathMatch: 'full',
    component: StandPerRegister,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDPERREGISTER_CONFIG.permission,
      showInMenu: STANDPERREGISTER_CONFIG.showInMenu,
      menuCategory: STANDPERREGISTER_CONFIG.menuCategory,
      menuSubcategory: STANDPERREGISTER_CONFIG.menuSubcategory,
      menuTitle: STANDPERREGISTER_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-cycle-rotation',
    pathMatch: 'full',
    component: StandCycleRotation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDCYCLEROTATION_CONFIG.permission,
      showInMenu: STANDCYCLEROTATION_CONFIG.showInMenu,
      menuCategory: STANDCYCLEROTATION_CONFIG.menuCategory,
      menuSubcategory: STANDCYCLEROTATION_CONFIG.menuSubcategory,
      menuTitle: STANDCYCLEROTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'harvest-preparation-stand-cycle-rotation',
    pathMatch: 'full',
    component: StandCycleRotationHarvestPreparation,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG.permission,
      showInMenu: HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG.showInMenu,
      menuCategory: HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG.menuCategory,
      menuSubcategory: HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG.menuSubcategory,
      menuTitle: HARVESTPREPARATIONSTANDCYCLEROTATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-certification',
    pathMatch: 'full',
    component: WoodCertification,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODCERTIFICATION_CONFIG.permission,
      showInMenu: WOODCERTIFICATION_CONFIG.showInMenu,
      menuCategory: WOODCERTIFICATION_CONFIG.menuCategory,
      menuSubcategory: WOODCERTIFICATION_CONFIG.menuSubcategory,
      menuTitle: WOODCERTIFICATION_CONFIG.localizationKey,
    },
  },
  {
    path: 'forestry-base',
    pathMatch: 'full',
    component: ForestryBase,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORESTRYBASE_CONFIG.permission,
      showInMenu: FORESTRYBASE_CONFIG.showInMenu,
      menuCategory: FORESTRYBASE_CONFIG.menuCategory,
      menuSubcategory: FORESTRYBASE_CONFIG.menuSubcategory,
      menuTitle: FORESTRYBASE_CONFIG.localizationKey,
    },
  },
  {
    path: 'forestry-base-variations',
    pathMatch: 'full',
    component: ForestryBaseVariations,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: FORESTRYBASE_VARIATIONS_CONFIG.permission,
      showInMenu: FORESTRYBASE_VARIATIONS_CONFIG.showInMenu,
      menuCategory: FORESTRYBASE_VARIATIONS_CONFIG.menuCategory,
      menuSubcategory: FORESTRYBASE_VARIATIONS_CONFIG.menuSubcategory,
      menuTitle: FORESTRYBASE_VARIATIONS_CONFIG.localizationKey,
    },
  },
  {
    path: 'protected-area',
    pathMatch: 'full',
    component: ProtectedArea,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROTECTEDAREA_CONFIG.permission,
      showInMenu: PROTECTEDAREA_CONFIG.showInMenu,
      menuCategory: PROTECTEDAREA_CONFIG.menuCategory,
      menuSubcategory: PROTECTEDAREA_CONFIG.menuSubcategory,
      menuTitle: PROTECTEDAREA_CONFIG.localizationKey,
    },
  },
  {
    path: 'protected-area-other-use-detail',
    pathMatch: 'full',
    component: ProtectedAreaOtherUseDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROTECTEDAREAOTHERUSEDETAIL_CONFIG.permission,
      showInMenu: PROTECTEDAREAOTHERUSEDETAIL_CONFIG.showInMenu,
      menuTitle: PROTECTEDAREAOTHERUSEDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-transformation-history',
    pathMatch: 'full',
    component: StandTransformationHistory,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDTRANSFORMATIONHISTORY_CONFIG.permission,
      showInMenu: STANDTRANSFORMATIONHISTORY_CONFIG.showInMenu,
      menuCategory: STANDTRANSFORMATIONHISTORY_CONFIG.menuCategory,
      menuSubcategory: STANDTRANSFORMATIONHISTORY_CONFIG.menuSubcategory,
      menuTitle: STANDTRANSFORMATIONHISTORY_CONFIG.localizationKey,
    },
  },
  {
    path: 'stand-transformation-history-detail',
    pathMatch: 'full',
    component: StandTransformationHistoryDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: STANDTRANSFORMATIONHISTORYDETAIL_CONFIG.permission,
      showInMenu: STANDTRANSFORMATIONHISTORYDETAIL_CONFIG.showInMenu,
      menuCategory: STANDTRANSFORMATIONHISTORYDETAIL_CONFIG.menuCategory,
      menuSubcategory: STANDTRANSFORMATIONHISTORYDETAIL_CONFIG.menuSubcategory,
      menuTitle: STANDTRANSFORMATIONHISTORYDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-certification-detail',
    pathMatch: 'full',
    component: WoodCertificationDetail,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODCERTIFICATIONDETAIL_CONFIG.permission,
      showInMenu: WOODCERTIFICATIONDETAIL_CONFIG.showInMenu,
      menuCategory: WOODCERTIFICATIONDETAIL_CONFIG.menuCategory,
      menuSubcategory: WOODCERTIFICATIONDETAIL_CONFIG.menuSubcategory,
      menuTitle: WOODCERTIFICATIONDETAIL_CONFIG.localizationKey,
    },
  },
  {
    path: 'wood-certification-detail-type',
    pathMatch: 'full',
    component: WoodCertificationDetailType,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: WOODCERTIFICATIONDETAILTYPE_CONFIG.permission,
      showInMenu: WOODCERTIFICATIONDETAILTYPE_CONFIG.showInMenu,
      menuCategory: WOODCERTIFICATIONDETAILTYPE_CONFIG.menuCategory,
      menuSubcategory: WOODCERTIFICATIONDETAILTYPE_CONFIG.menuSubcategory,
      menuTitle: WOODCERTIFICATIONDETAILTYPE_CONFIG.localizationKey,
    },
  },
  {
    path: 'other-use',
    pathMatch: 'full',
    component: OtherUse,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: OTHERUSE_CONFIG.permission,
      showInMenu: OTHERUSE_CONFIG.showInMenu,
      menuCategory: OTHERUSE_CONFIG.menuCategory,
      menuSubcategory: OTHERUSE_CONFIG.menuSubcategory,
      menuTitle: OTHERUSE_CONFIG.localizationKey,
    },
  },
  {
    path: 'property',
    pathMatch: 'full',
    component: Property,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTY_CONFIG.permission,
      showInMenu: PROPERTY_CONFIG.showInMenu,
      menuCategory: PROPERTY_CONFIG.menuCategory,
      menuSubcategory: PROPERTY_CONFIG.menuSubcategory,
      menuTitle: PROPERTY_CONFIG.localizationKey,
    },
  },
  {
    path: 'property-origin-destination',
    pathMatch: 'full',
    component: PropertyOriginDestination,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: PROPERTYORIGINDESTINATION_CONFIG.permission,
      showInMenu: PROPERTYORIGINDESTINATION_CONFIG.showInMenu,
    },
  },
  {
    path: 'gis-inconsistency-dashboard',
    pathMatch: 'full',
    component: GisInconsistencyDashboard,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISINCONSISTENCYDASHBOARD_CONFIG.permission,
      showInMenu: GISINCONSISTENCYDASHBOARD_CONFIG.showInMenu,
      menuCategory: GISINCONSISTENCYDASHBOARD_CONFIG.menuCategory,
      menuSubcategory: GISINCONSISTENCYDASHBOARD_CONFIG.menuSubcategory,
      menuTitle: GISINCONSISTENCYDASHBOARD_CONFIG.localizationKey,
    },
  },
  {
    path: 'other-use-inconsistency-only-in-zendra', pathMatch: 'full', component: OtherUseInconsistencyOnlyInZendra,
    canActivate: [authGuard, permissionGuard], data: { requiredPolicy: 'PlanningLocation.OtherUses', showInMenu: false },
  },
  {
    path: 'other-use-inconsistency-only-in-gis', pathMatch: 'full', component: OtherUseInconsistencyOnlyInGis,
    canActivate: [authGuard, permissionGuard], data: { requiredPolicy: 'PlanningLocation.OtherUses', showInMenu: false },
  },
  {
    path: 'gis-stand-inconsistency-only-in-gis',
    pathMatch: 'full',
    component: GisStandInconsistencyOnlyInGis,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISSTANDINCONSISTENCYONLYINGIS_CONFIG.permission,
      showInMenu: GISSTANDINCONSISTENCYONLYINGIS_CONFIG.showInMenu,
      menuCategory: GISSTANDINCONSISTENCYONLYINGIS_CONFIG.menuCategory,
      menuSubcategory: GISSTANDINCONSISTENCYONLYINGIS_CONFIG.menuSubcategory,
      menuTitle: GISSTANDINCONSISTENCYONLYINGIS_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-register-inconsistency-only-in-gis',
    pathMatch: 'full',
    component: GisRegisterInconsistencyOnlyInGis,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISREGISTERINCONSISTENCYONLYINGIS_CONFIG.permission,
      showInMenu: GISREGISTERINCONSISTENCYONLYINGIS_CONFIG.showInMenu,
      menuCategory: GISREGISTERINCONSISTENCYONLYINGIS_CONFIG.menuCategory,
      menuSubcategory: GISREGISTERINCONSISTENCYONLYINGIS_CONFIG.menuSubcategory,
      menuTitle: GISREGISTERINCONSISTENCYONLYINGIS_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-register-inconsistency-only-in-zendra',
    pathMatch: 'full',
    component: GisRegisterInconsistencyOnlyInZendra,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG.permission,
      showInMenu: GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG.showInMenu,
      menuCategory: GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG.menuCategory,
      menuSubcategory: GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG.menuSubcategory,
      menuTitle: GISREGISTERINCONSISTENCYONLYINZENDRA_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-protected-area-inconsistency-only-in-gis',
    pathMatch: 'full',
    component: GisProtectedAreaInconsistencyOnlyInGis,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG.permission,
      showInMenu: false,
      menuCategory: GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG.menuCategory,
      menuSubcategory: GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG.menuSubcategory,
      menuTitle: GISPROTECTEDAREAINCONSISTENCYONLYINGIS_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-protected-area-inconsistency-only-in-zendra',
    pathMatch: 'full',
    component: GisProtectedAreaInconsistencyOnlyInZendra,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG.permission,
      showInMenu: false,
      menuCategory: GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG.menuCategory,
      menuSubcategory: GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG.menuSubcategory,
      menuTitle: GISPROTECTEDAREAINCONSISTENCYONLYINZENDRA_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-stand-inconsistency-only-in-zendra',
    pathMatch: 'full',
    component: GisStandInconsistencyOnlyInZendra,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG.permission,
      showInMenu: GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG.showInMenu,
      menuCategory: GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG.menuCategory,
      menuSubcategory: GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG.menuSubcategory,
      menuTitle: GISSTANDINCONSISTENCYONLYINZENDRA_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-stand-inconsistency-disabled-in-zendra',
    pathMatch: 'full',
    component: GisStandInconsistencyDisabledInZendra,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG.permission,
      showInMenu: GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG.showInMenu,
      menuCategory: GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG.menuCategory,
      menuSubcategory: GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG.menuSubcategory,
      menuTitle: GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG.localizationKey,
    },
  },
  {
    path: 'gis-stand-area-difference',
    pathMatch: 'full',
    component: GisStandAreaDifference,
    canActivate: [authGuard, permissionGuard],
    data: {
      requiredPolicy: GISSTANDAREADIFFERENCE_CONFIG.permission,
      showInMenu: GISSTANDAREADIFFERENCE_CONFIG.showInMenu,
      menuCategory: GISSTANDAREADIFFERENCE_CONFIG.menuCategory,
      menuSubcategory: GISSTANDAREADIFFERENCE_CONFIG.menuSubcategory,
      menuTitle: GISSTANDAREADIFFERENCE_CONFIG.localizationKey,
    },
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'cycle',
  }
];
